module.exports = __webpack_public_path__ + "img/gate1.b25cf281.png";